import Bar from '../../../../components/elements/Bar';
import { Pencil } from 'lucide-react';
import List from '../../../../components/elements/List';
import { usePermission } from '../../../../hooks/usePermission';
import ApprovalItemActions from '../../../approval/components/ApprovalItemActions';

const BiblioView = ({ data, onEdit }) => {
  const { isEditable } = usePermission();
  const prepareData = () => {
    if (!data) return [];
    return [
      { name: 'Označení', value: data.designation },
      { name: 'Název', value: data.title },
      { name: 'Rok vydání', value: data.publication_year },
    ];
  };

  return (
    <div>
      <Bar
        text="Detail"
        content={
          isEditable
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  onClick={onEdit}
                  data-testid="biblio-view-edit-btn"
                />,
              ]
            : []
        }
      />
      <ApprovalItemActions objectType="biblio" objectId={data?.id} status={data?.status} />
      <List data={prepareData()} />
      <div className="mb-px">
        <Bar text="Soubory" />

        {(data?.files || []).map((file) => (
          <a
            href={file.url}
            target="_blank"
            key={file.id}
            className="block p-2 text-sm text-gray-700"
            rel="noreferrer"
            data-testid={`biblio-view-file-link-${file.id}`}
          >
            {file.title}
          </a>
        ))}
      </div>
    </div>
  );
};

export default BiblioView;
